import authService from '@/services/AuthService';
import { formatPhoneForPayload } from '@/utils/formUtils';

export const onSubmitEmail = async (email: string): Promise<boolean> => {
  try {
    await authService.getUserByEmail(email);
  } catch (error) {
    return false;
  }
  return true;
};

export const onResetPassword = async (email: string, create_new_password: boolean = false): Promise<true | string> => {
  await authService.forgotPassword({ email, create_new_password });
  return true;
};

export const onCheckPhoneNumberTaken = async (phone: string): Promise<boolean> => {
  const formattedPhone = formatPhoneForPayload(phone);
  try {
    await authService.checkPhoneNumberIsTaken(formattedPhone);
  } catch (error) {
    return false;
  }
  return true;
};

export const onSendVerificationToken = async (phone: string): Promise<string> => {
  const formattedPhone = formatPhoneForPayload(phone);
  try {
    const response = await authService.getPhoneVerificationCode(formattedPhone);
    return response.verification_id;
  } catch (error) {
    return '';
  }
};
